import { FormulaCase } from "./image";

export enum UserCheckStatus {
  Correct = "correct",
  Incorrect = "incorrect",
  Skipped = "skipped",
  NotInReview = "not_in_review",
}

export interface IUserCheck {
  userId: number;
  imageHash: string;
  status: UserCheckStatus;
  formula: string | null;
  formulaCase: FormulaCase | null;
  skippedComment: string | null;
  createdAt: Date | null;
  updatedAt: Date | null;
}
